
/*
const dev = {
    url: {        
    URL:  process.env.REACT_APP_API_GATEWAY_URL,
       }
    };
 

const prod = {
    url: {    
        URL: "https://archicubedgateway.infocubed.com:443"
    }
   };
*/

  // export const config = process.env.NODE_ENV === 'development' ? dev : prod;
export const config =
{
    url: {
        URL: process.env.REACT_APP_API_GATEWAY_URL,
    }
};
export const MAX_COST = 9999999999;
export const MIN_COST = -MAX_COST;